var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 53.828 30.341",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 9.288l-7.576 15.127c-.332.4-.57.873-.693 1.384 0 0-.04.193-.058.29a3.686 3.686 0 00.828 2.92c1.285 1.537 3.527 1.779 5.008.54.924-.772 1.37-1.984 1.179-3.207z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72.171 20.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.085-20.618A26.914 26.444 0 0072.171 5.826a26.914 26.444 0 00.045 1.544h2.217a24.702 24.271 0 01-.05-1.544 24.702 24.271 0 0124.702-24.271 24.702 24.271 0 0124.702 24.271 24.702 24.271 0 01-.05 1.544h2.217A26.914 26.444 0 00126 5.826a26.914 26.444 0 00-26.914-26.444z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: 75.346,
    y: 5.508,
    ry: 0.931
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: -122.85,
    y: -6.755,
    ry: 0.931,
    transform: "rotate(180.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: -16.914,
    y: -100.02,
    ry: 0.931,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: 65.012,
    y: -44.964,
    ry: 0.931,
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: 31.549,
    y: -83.171,
    ry: 0.931,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: -106.37,
    y: 53.983,
    ry: 0.931,
    transform: "scale(-1 1) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.943,
    height: 1.862,
    x: -67.398,
    y: 88.209,
    ry: 0.931,
    transform: "scale(-1 1) rotate(60)"
  }))));
}

export default SvgScore;